"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toastr = require("toastr");
require("./main.scss");
var MainComponent = (function () {
    function MainComponent() {
        this.controller = MainController;
        this.template = require("./main.html");
    }
    return MainComponent;
}());
exports.MainComponent = MainComponent;
var MainController = (function () {
    function MainController($scope, $mdDialog, $mdMedia, youtubeService, blockUI, $location, $anchorScroll) {
        "ngInject";
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$mdMedia = $mdMedia;
        this.youtubeService = youtubeService;
        this.blockUI = blockUI;
        this.$location = $location;
        this.$anchorScroll = $anchorScroll;
        this.bottomId = "bottom";
        this.listPlaceholder = "Пример заполнения:\nhttps://www.youtube.com/watch?v=TadQGyFWPHc\nhttps://www.youtube.com/watch?v=DnQd2wQRoJ0\nqmLJvTiL_Rw";
    }
    Object.defineProperty(MainController.prototype, "hasVideosInStorage", {
        get: function () {
            return localStorage.videosList !== undefined &&
                localStorage.videosList !== null &&
                localStorage.videosList.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    MainController.prototype.$onInit = function () {
        var _this = this;
        this.$scope.$watch(function () { return localStorage.videosList; }, function () {
            _this.videosList = localStorage.videosList ? JSON.parse(localStorage.videosList).join("\n") : undefined;
            _this.videosListIsEmpty = !_this.videosList || _this.videosList.length === 0;
            if (_this.videosListIsEmpty) {
                _this.videosList = _this.listPlaceholder;
            }
        });
    };
    MainController.prototype.checkVideos = function () {
        var _this = this;
        this.blockUI.start("Выполняется проверка...");
        this.youtubeService.checkVideos(this.videosList)
            .then(function (value) {
            _this.clearStats();
            _this.lastCheckingResult = value;
            _this.$scope.$apply(function () {
                _this.blockUI.stop();
                if (_this.$mdMedia("xs")) {
                    _this.goToBottom();
                }
            });
        }, function (reason) { return _this.$scope.$apply(function () { return _this.blockUI.stop(); }); });
    };
    MainController.prototype.setLikes = function () {
        var _this = this;
        this.blockUI.start("Выполняется проставление лайков...");
        var lastCheckingResult = this.lastCheckingResult;
        this.clearStats();
        var lastSuccessedVideos = [];
        var lastFailedVideos = [];
        try {
            this.youtubeService.setRating(lastCheckingResult.withoutLikes, "like", function (videoId) {
                lastSuccessedVideos.push(videoId);
            }, function (videoId, errorMsg) {
                lastFailedVideos.push({ id: videoId, errorMsg: errorMsg });
            }).then(function () {
                _this.lastSuccessedVideos = lastSuccessedVideos;
                _this.lastFailedVideos = lastFailedVideos;
                _this.$scope.$apply(function () { return _this.blockUI.stop(); });
            });
        }
        catch (_a) {
            this.clearStats();
            this.blockUI.stop();
            this.lastCheckingResult = lastCheckingResult;
        }
    };
    MainController.prototype.saveList = function () {
        localStorage.videosList = JSON.stringify(this.videosList.split("\n"));
        toastr.success("Список видео сохранён.");
    };
    MainController.prototype.showDialog = function (id) {
        this.$mdDialog.show({
            contentElement: "#" + id,
            parent: document.body
        });
        console.log(this.lastFailedVideosShown);
    };
    MainController.prototype.closeDialog = function () {
        this.$mdDialog.hide();
    };
    MainController.prototype.clearList = function () {
        this.$mdDialog.hide();
        localStorage.removeItem("videosList");
        toastr.success("Список видео удалён.");
    };
    MainController.prototype.loadList = function () {
        this.videosList = JSON.parse(localStorage.videosList).join("\n");
        this.videosListIsEmpty = false;
    };
    MainController.prototype.onListFocus = function () {
        if (this.videosList === this.listPlaceholder) {
            this.videosList = null;
        }
    };
    MainController.prototype.onListBlur = function () {
        if (!this.videosList) {
            this.videosList = this.listPlaceholder;
            this.videosListIsEmpty = true;
        }
    };
    MainController.prototype.onListChange = function () {
        if (this.videosList) {
            this.videosListIsEmpty = false;
        }
        else {
            this.videosListIsEmpty = true;
        }
    };
    MainController.prototype.clearStats = function () {
        this.lastSuccessedVideos = null;
        this.lastFailedVideos = null;
        this.lastCheckingResult = null;
    };
    MainController.prototype.goToBottom = function () {
        this.$location.hash(this.bottomId);
        this.$anchorScroll();
    };
    MainController.prototype.forceUpdate = function () {
        this.$scope.$eval();
    };
    return MainController;
}());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/main.component.ts
 **/